import axios from 'axios';

export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_PRODUCT = "GET_PRODUCT";
export const GET_FILTER_OPTIONS = "GET_FILTER_OPTIONS";
export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const CREATE_BULK_PRODUCTS = "CREATE_BULK_PRODUCTS";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const UPDATE_PRICES_BULK = "UPDATE_PRICES_BULK";

const API_URL = `${process.env.REACT_APP_API_URL}/products`;

export const getProducts = (params = {}) => async (dispatch: any) => {
    try {
        const response = await axios.get(API_URL, { params });
        dispatch({
            type: GET_PRODUCTS,
            payload: response.data
        });
    } catch (error) {
        console.error("Ürünler getirilirken hata oluştu:", error);
    }
};

export const getProduct = (id: string) => async (dispatch: any) => {
    try {
        const response = await axios.get(`${API_URL}/${id}`);
        dispatch({
            type: GET_PRODUCT,
            payload: response.data
        });
    } catch (error) {
        console.error("Ürün getirilirken hata oluştu:", error);
    }
};

export const createProduct = (formData: FormData) => async (dispatch: any) => {
    try {
        const response = await axios.post(API_URL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        dispatch({
            type: CREATE_PRODUCT,
            payload: response.data
        });
        return response.data;
    } catch (error) {
        console.error("Ürün oluşturulurken hata oluştu:", error);
        throw error;
    }
};

export const createBulkProducts = (formData: FormData) => async (dispatch: any) => {
    try {
        const response = await axios.post(`${API_URL}/bulk`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        dispatch({
            type: CREATE_BULK_PRODUCTS,
            payload: response.data
        });
        return response.data;
    } catch (error) {
        console.error("Toplu ürün oluşturulurken hata oluştu:", error);
        throw error;
    }
};

export const updateProduct = (id: string, formData: FormData) => async (dispatch: any) => {
    try {
        const response = await axios.put(`${API_URL}/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        dispatch({
            type: UPDATE_PRODUCT,
            payload: response.data
        });
        return response.data;
    } catch (error) {
        console.error("Ürün güncellenirken hata oluştu:", error);
        throw error;
    }
};

export const deleteProduct = (id: string) => async (dispatch: any) => {
    try {
        await axios.delete(`${API_URL}/${id}`);
        dispatch({
            type: DELETE_PRODUCT,
            payload: id
        });
    } catch (error) {
        console.error("Ürün silinirken hata oluştu:", error);
        throw error;
    }
};

export const getFilterOptions = () => async (dispatch: any) => {
    try {
        // Bağımsız /api/filters endpoint
        const filtersUrl = `${process.env.REACT_APP_API_URL}/filters`;
        console.log('getFilterOptions - URL:', filtersUrl);
        const response = await axios.get(filtersUrl);
        dispatch({ type: GET_FILTER_OPTIONS, payload: response.data });
    } catch (error) {
        console.error('Filtre seçenekleri getirilirken hata oluştu:', error);
    }
};

export const updatePricesBulk = (updateData: {
    percentage: number;
    operation: 'increase' | 'decrease';
    filters: any;
}) => async (dispatch: any) => {
    try {
        const response = await axios.put(`${API_URL}/bulk-price-update`, updateData);
        dispatch({
            type: UPDATE_PRICES_BULK,
            payload: response.data
        });
        return response.data;
    } catch (error: any) {
        console.error("Toplu fiyat güncellenirken hata oluştu:", error);
        throw error;
    }
};